"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldYesNo = exports.ModelMutatorYesNo = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorYesNo extends collection_field_1.ModelMutator {
    manual(newValue) {
        this.state.setFieldValue(this.field.id, newValue);
    }
}
exports.ModelMutatorYesNo = ModelMutatorYesNo;
class CollectionModelFieldYesNo extends collection_field_1.CollectionModelField {
    static isYesNoField(f) {
        return f.schema.type === CollectionModelFieldYesNo.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorYesNo(this);
        }
        return this._Mutator;
    }
    get value() {
        return Boolean(this.stateValue);
    }
    hasValue() {
        return true;
    }
}
exports.CollectionModelFieldYesNo = CollectionModelFieldYesNo;
CollectionModelFieldYesNo.TYPE = core_api_1.IkeFieldType.YES_NO;
//# sourceMappingURL=yes.no.field.js.map